// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2suuD","vLegacy":"SelectSecondary_vLegacy__2Kfvl","error":"SelectSecondary_error__2V682","disabled":"SelectSecondary_disabled__Ho1KI"};